import React from 'react';
import "./table.css";
import Search from "../search/search-component";
import Paginator from "../paginator/paginator-component";
import {Link} from "react-router-dom";


const Table = (
  {
    loading,
    columns,
    data,
    page,
    changePage,
    searchChange,
    searchValue,
    reportUrl
  }
) => {
  return (
    <div className="table_container shadow">
      <div className="table_container__meta_header">
        <Search
          width="85%"
          placeholder="Type word and hit enter"
          onChange={searchChange}
          searchValue={searchValue}
        />
        <div className="table_container__meta_header__paginator ">
          <Paginator
            changePage={changePage}
            page={page}
            data={data}
          />
        </div>
      </div>
      <div className="table_container__header">
        {
          columns.map((col, i) => (
            <div key={i} className="table_container__header__col" style={{width: col.width}}>
              {col.displayName}
            </div>
          ))
        }
      </div>
      <div className="table_container__body">
        {
          data[page].map((d, i) => (
            <div key={i} className="table_container__body__row border_bottom">
              {
                columns.map((col, i) => (
                  <div
                    key={i}
                    className="table_container__body__row__field"
                    style={{width: '33.333333333333333%'}}
                  >
                    {
                      col.name === 'percent'
                        ?
                      `${d[col.name]}%`
                        :
                        col.name === 'term'
                        ?
                          <Link
                            to={`/word-verbatims?reportUrl=${reportUrl}&word=${d[col.name]}`}
                            className="table_container__body__row__field__link"
                          >{d[col.name]}</Link>
                        :
                        d[col.name]
                    }
                  </div>
                ))
              }
            </div>
          ))
        }
      </div>
      <div className="table_container__footer">

      </div>
    </div>
  )
};

export default Table;


// WEBPACK FOOTER //
// ./src/components/table/table-component.js